import mathHelper from '../Helpers/mathHelper';
import moneyHelper from '../Helpers/moneyHelper';
import React from 'react';
import PlanningProgressGraph from '../Elements/PlanningProgressGraph';

export default class PlanningDetailsItem {
  constructor(item) {
    this.PlanningDetailId = item.planningDetailId;
    this.PricingId = item.pricingId;
    this.PricingDetailId = item.pricingDetailId;
    this.OpportunityId = item.opportunityId;
    this.CreatedOn = item.createdOn;
    this.FieldworkOrderNumber = item.fieldworkOrderNumber;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.NumberOfPlannedAssignments = item.numberOfPlannedAssignments;
    this.NumberOfContractedAssignments = item.numberOfContractedAssignments;
    this.OwningOfficeRevenueContracted = item.owningOfficeRevenueContracted;
    this.FieldworkOfficeRevenueContracted = item.fieldworkOfficeRevenueContracted;
    this.FieldworkOfficeCurrency = item.fieldWorkOfficeCurrency;
    this.OwningOfficeCurrency = item.owningOfficeCurrency;
    this.ClientName = item.clientName;
    this.OpportunityName = item.opportunityName;
    this.ServiceName = item.serviceName;
    this.PricingDetailName = item.pricingDetailName;
    this.OpportunityStatuscode = item.opportunityStatuscode;
    this.PlanningDetailStatusCompleted = item.planningDetailStatusCompleted;
    this.CountryId = item.countryId;
    this.CountryName = item.countryName;
    this.ServiceId = item.serviceId;
    this.ClientId = item.clientId;
    this.ClientOwner = item.clientOwner;
    this.EffectiveAccountManager = item.effectiveAccountManager;
    this.EvalBonusPerCycle = item.evalBonusPerCycle;
    this.Status = item.status;
    this.TargetAssignmentRate1 = item.targetAssignmentRate1;
    this.TargetAssignmentRate2 = item.targetAssignmentRate2;
    this.TargetAssignmentRate3 = item.targetAssignmentRate3;
    this.TargetAssignmentRate4 = item.targetAssignmentRate4;
    this.TargetCompletionRate1 = item.targetCompletionRate1;
    this.TargetCompletionRate2 = item.targetCompletionRate2;
    this.TargetCompletionRate3 = item.targetCompletionRate3;
    this.TargetCompletionRate4 = item.targetCompletionRate4;

    this.NumberOfAssignmentsAll = item.numberOfAssignmentsAll; //Number of Assigned Assignments
    this.NumberOfAssignmentsSelfAssigned = item.numberOfAssignmentsSelfAssigned;
    this.NumberOfAssignmentsCompleted = item.numberOfAssignmentsCompleted;
    this.NumberOfAssignmentsFinalized = item.numberOfAssignmentsFinalized;
    this.NumberOfAssignmentsExcluded = item.numberOfAssignmentsExcluded;
    this.NumberOfAssignmentsInvoiced = item.numberOfAssignmentsInvoiced;
    this.NumberOfAssignmentsExcludedEx = item.numberOfAssignmentsExcludedEx;
    this.NumberOfAssignmentsExcludedPS = item.numberOfAssignmentsExcludedPS;
    this.NumberOfAssignmentsExcludedBC = item.numberOfAssignmentsExcludedBC;
    this.OfficeName = item.officeName;
    this.PricingOwningOfficeFeePerEval = item.pricingOwningOfficeFeePerEval;
    this.PricingFieldworkOfficeFeePerEval = item.pricingFieldworkOfficeFeePerEval;
    this.EvalFeePerEval = item.evalFeePerEval;
    this.PricingDetailEditorCostPerEval = item.pricingDetailEditorCostPerEval;
    this.ActualEvaluatorFee = item.actualEvaluatorFee;
    this.ActualEvaluatorFeePerAssignment = item.actualEvaluatorFeePerAssignment;
    this.ClientFeeOwningOffice = item.clientFeeOwningOffice;
    this.ClientFeeFieldworkOffice = item.clientFeeFieldworkOffice;
    this.ClientFeeUsd = item.clientFeeUsd;
    this.FieldworkFeeOwningOffice = item.fieldworkFeeOwningOffice;
    this.FieldworkFeeFieldworkOffice = item.fieldworkFeeFieldworkOffice;
    this.FieldworkFeeUsd = item.fieldworkFeeUsd;
    this.EvaluatorFeeLeftoverOwningOffice = item.evaluatorFeeLeftoverOwningOffice;
    this.EvaluatorFeeLeftoverFieldworkOffice = item.evaluatorFeeLeftoverFieldworkOffice;
    this.EvaluatorFeeLeftoverUsd = item.evaluatorFeeLeftoverUsd;

    this.NumberOfAssignmentsOpen = item.numberOfAssignmentsOpen;
    this.NumberOfAssignmentsNew = item.numberOfAssignmentsNew;
    this.NumberOfAssignmentsIncomplete = item.numberOfAssignmentsIncomplete;
    this.NumberOfAssignmentsApolloCompleted = item.numberOfAssignmentsApolloCompleted;
    this.NumberOfAssignmentsCollaboration = item.numberOfAssignmentsCollaboration;
    this.NumberOfAssignmentsHoldA = item.numberOfAssignmentsHoldA;
    this.NumberOfAssignmentsHoldB = item.numberOfAssignmentsHoldB;
    this.NumberOfAssignmentsReviewed = item.numberOfAssignmentsReviewed;
    this.NumberOfAssignmentsApolloFinalized = item.numberOfAssignmentsApolloFinalized;
    this.NumberOfAssignmentsEmailed = item.numberOfAssignmentsEmailed;
    this.NumberOfAssignmentsClientFinalized = item.numberOfAssignmentsClientFinalized;
    this.NumberOfAssignmentsLocked = item.numberOfAssignmentsLocked;
    this.NumberOfAssignmentsGroupedOpen = item.numberOfAssignmentsGroupedOpen;
    this.NumberOfAssignmentsGroupedInProgress = item.numberOfAssignmentsGroupedInProgress;
    this.NumberOfAssignmentsGroupedCompleted = item.numberOfAssignmentsGroupedCompleted;

    this.ServiceName = item.serviceName;

    this.TotalContractedFeeAmount = this.EvalFeePerEval * this.NumberOfContractedAssignments;
    this.TotalPlannedFeeAmount = this.EvalFeePerEval * this.NumberOfPlannedAssignments;

    this.TotalPlannedBonusAmount =
      (this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfPlannedAssignments;
    this.PercentageOfContractedEvaluatorFee = mathHelper.PercentageText(
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments,
      this.PricingFieldworkOfficeFeePerEval
    );
    this.PlannedShopperFeePerAssignedAssignments =
      (this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments) * this.NumberOfAssignmentsAll;

    this.TotalContractedEvaluatorFeePlusBonus = this.TotalContractedFeeAmount + this.EvalBonusPerCycle;
    this.TotalContractedEvaluatorFeePerAssignmentInclBonus =
      this.EvalFeePerEval + this.EvalBonusPerCycle / this.NumberOfContractedAssignments;
    this.TotalPlannedEvaluatorFeePlusBonus = this.TotalPlannedFeeAmount + this.TotalPlannedBonusAmount;
    this.TotalPlannedEvaluatorFeePerAssignment =
      this.NumberOfPlannedAssignments === 0
        ? 0
        : this.EvalFeePerEval + this.TotalPlannedBonusAmount / this.NumberOfPlannedAssignments;

    this.PlannedRevenueOwningOffice = this.NumberOfPlannedAssignments * this.PricingOwningOfficeFeePerEval;
    this.InvoicedRevenueOwningOffice = this.NumberOfAssignmentsInvoiced * this.PricingOwningOfficeFeePerEval;
    this.PlannedRevenueFieldworkOffice = this.NumberOfPlannedAssignments * this.PricingFieldworkOfficeFeePerEval;
    this.InvoicedRevenueFieldworkOffice = this.NumberOfAssignmentsInvoiced * this.PricingFieldworkOfficeFeePerEval;
    this.RealizedRevenueFieldworkOffice =
      (this.NumberOfAssignmentsExcludedBC + this.NumberOfAssignmentsFinalized) * this.PricingFieldworkOfficeFeePerEval;

    this.PercentageOfActualEvaluatorFee = mathHelper.PercentageText(
      this.ActualEvaluatorFeePerAssignment,
      this.PricingFieldworkOfficeFeePerEval
    );

    this.PercentageOfAssignedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsAll,
      this.NumberOfPlannedAssignments
    );
    this.PercentageOfCompletedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsCompleted,
      this.NumberOfPlannedAssignments
    );
    this.PercentageOfFinalizedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsFinalized,
      this.NumberOfPlannedAssignments
    );
    this.PercentageOfExcludedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsExcluded,
      this.NumberOfPlannedAssignments
    );
    this.PercentageOfInvoicedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsInvoiced,
      this.NumberOfPlannedAssignments
    );
    this.PercentageOfSelfAssignedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsSelfAssigned,
      this.NumberOfPlannedAssignments
    );

    this.Selected = true;
  }

  static IsThisFieldEditable(fieldname) {
    return ['StartDate', 'EndDate', 'NumberOfPlannedAssignments'].includes(fieldname);
  }

  static IsThisFieldADate(fieldname) {
    this.DateFields().includes(fieldname);
  }

  static DateFields = ['CreatedOn', 'StartDate', 'EndDate'];

  static FieldsToShowInListTable() {
    return [];
  }

  static NameOfTheIdField() {
    return 'PlanningDetailId';
  }

  static FormatMoney(value, currencyCode) {
    if (value === null || value === undefined || isNaN(value)) {
      return '-';
    }
    return moneyHelper.toMoneyFormat(value, currencyCode);
  }

  static BoolFields = [];

  //MoneyFields_FieldworkOffice()
  static MoneyFieldsSecondary = [
    'FieldworkOfficeRevenueContracted',
    'PricingFieldworkOfficeFeePerEval',
    'PricingFeePerEval',
    'EvalFeePerEval',
    'PricingDetailEditorCostPerEval',
    'PlannedRevenueFieldworkOffice',
    'InvoicedRevenueFieldworkOffice',
    'EvalBonusPerCycle',
    'TotalContractedFeeAmount',
    'TotalPlannedBonusAmount',
    'PlannedShopperFeePerAssignedAssignments',
    'ActualEvaluatorFee',
    'TotalContractedEvaluatorFeePlusBonus',
    'TotalContractedEvaluatorFeePerAssignmentInclBonus',
    'TotalPlannedEvaluatorFeePlusBonus',
    'TotalPlannedEvaluatorFeePerAssignment',
    'ActualEvaluatorFee',
    'ActualEvaluatorFeePerAssignment',
    'RealizedRevenueFieldworkOffice',
  ];

  static CurrencySecondary() {
    return 'FieldworkOfficeCurrency';
  }

  // MoneyFields_OwningOffice
  static MoneyFields = [
    'OwningOfficeRevenueContracted',
    'PricingOwningOfficeFeePerEval',
    'PlannedRevenueOwningOffice',
    'RealizedRevenueOwningOffice',
    'InvoicedRevenueOwningOffice',
  ];

  static Currency() {
    return 'OwningOfficeCurrency';
  }

  // Own id for the column selector: the Planning and Reporting tabs share one route, so
  // without it both would read and write the same hidden-columns cookie.
  static uniquePageIdForColumnCookies = 'planningreporting';

  static uniquePageIdForBlockCookies = 'planningdfro';
  static BlocksInDataTable = [
    { name: 'info', label: 'Info', checkedDefault: false, bgcolor: '#DCDCDC' },
    { name: 'graph', label: 'Graph', checkedDefault: false, bgcolor: '' },
    { name: 'percentages', label: 'Percentages', checkedDefault: true, bgcolor: '#FFFF00' },
    { name: 'revenues', label: 'Revenues', checkedDefault: false, bgcolor: '#4CC552' },
    { name: 'fees', label: 'Fees', checkedDefault: false, bgcolor: '#EE9A4D' },
    // One status view at a time. Both blocks count the same shops, but the summary rolls up
    // every platform into three Bravo categories while the detail lists the Apollo statuses
    // one by one and leaves third-party jobs out, so side by side they repeat the column
    // names Open and Completed over figures that cannot agree.
    {
      name: 'statussummary',
      label: 'Status Summary (all platforms)',
      checkedDefault: true,
      bgcolor: '#ADD8E6',
      exclusiveGroup: 'statusview',
    },
    {
      name: 'assignments',
      label: 'Assignment Detail (Apollo only)',
      checkedDefault: false,
      bgcolor: '#6698FF',
      exclusiveGroup: 'statusview',
    },
    { name: 'multicurrencyfees', label: 'Fees (Multi-currency)', checkedDefault: false, bgcolor: '#90EE90' },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Id', orderById: 'PlanningDetailId', data: 'PlanningDetailId', block: 'info' },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: 'ClientName',
        // Free text, so the column is bounded by a width rather than by a character count: the
        // grid ellipsizes whatever does not fit and offers the whole value behind the eye, and
        // the user can drag the column wider or narrower from there.
        defaultWidth: 260,
      },
      {
        label: 'Service',
        orderById: 'Service',
        data: 'ServiceName',
        defaultWidth: 300,
      },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName' },
      { label: 'StartDate', orderById: 'StartDate', data: 'StartDate' },
      { label: 'EndDate', orderById: 'EndDate', data: 'EndDate' },
      { label: 'Fw Office', orderById: 'Office', data: 'OfficeName', block: 'info' },
      {
        label: 'Account Manager',
        orderById: 'AccountManager',
        data: (item) => (item.EffectiveAccountManager ? item.EffectiveAccountManager : '-'),
        block: 'info',
      },
      { label: 'FW Period', orderById: 'fwperiod', data: 'FieldworkOrderNumber', block: 'info' },
      { label: 'Status', orderById: 'Status', data: 'Status', block: 'info' },

      { label: 'Graph', orderById: '', data: (item) => <PlanningProgressGraph item={item} />, block: 'graph' },

      { label: 'Scheduled %', orderById: 'scheduled', data: 'PercentageOfAssignedAssignments', block: 'percentages' },
      { label: 'Completed %', orderById: 'completed', data: 'PercentageOfCompletedAssignments', block: 'percentages' },
      { label: 'Finalized %', orderById: 'finalized', data: 'PercentageOfFinalizedAssignments', block: 'percentages' },
      { label: 'Invoiced %', orderById: 'invoiced', data: 'PercentageOfInvoicedAssignments', block: 'percentages' },
      { label: 'Excluded %', orderById: 'excluded', data: 'PercentageOfExcludedAssignments', block: 'percentages' },
      {
        label: 'Self-assigned %',
        orderById: 'selfassigned',
        data: 'PercentageOfSelfAssignedAssignments',
        block: 'percentages',
      },

      {
        label: 'Planned Revenue',
        orderById: 'plannedrevenue',
        data: 'PlannedRevenueFieldworkOffice',
        block: 'revenues',
      },
      {
        label: 'Realized Revenue',
        orderById: 'realizedrevenue',
        data: 'RealizedRevenueFieldworkOffice',
        block: 'revenues',
      },
      {
        label: 'Invoiced Revenue',
        orderById: 'invoicedrevenue',
        data: 'InvoicedRevenueFieldworkOffice',
        block: 'revenues',
      },

      {
        label: 'Contracted Ev. Fee %',
        orderById: 'PercentageOfContractedEvaluatorFee',
        data: 'PercentageOfContractedEvaluatorFee',
        block: 'fees',
      },
      {
        label: 'Actual Evaluator Fee %',
        orderById: 'PercentageOfActualEvaluatorFee',
        data: 'PercentageOfActualEvaluatorFee',
        block: 'fees',
      },

      {
        label: 'Open',
        orderById: 'NumberOfAssignmentsGroupedOpen',
        data: 'NumberOfAssignmentsGroupedOpen',
        block: 'statussummary',
      },
      {
        label: 'In Progress',
        orderById: 'NumberOfAssignmentsGroupedInProgress',
        data: 'NumberOfAssignmentsGroupedInProgress',
        block: 'statussummary',
      },
      {
        label: 'Completed',
        orderById: 'NumberOfAssignmentsGroupedCompleted',
        data: 'NumberOfAssignmentsGroupedCompleted',
        block: 'statussummary',
      },
      {
        label: 'Required (Planned shopcount)',
        orderById: 'NumberOfPlannedAssignments',
        data: 'NumberOfPlannedAssignments',
        block: 'assignments',
      },
      {
        label: 'Open / Not yet scheduled',
        orderById: 'NumberOfAssignmentsOpen',
        data: 'NumberOfAssignmentsOpen',
        block: 'assignments',
      },
      { label: 'New', orderById: 'NumberOfAssignmentsNew', data: 'NumberOfAssignmentsNew', block: 'assignments' },
      {
        label: 'Incomplete',
        orderById: 'NumberOfAssignmentsIncomplete',
        data: 'NumberOfAssignmentsIncomplete',
        block: 'assignments',
      },
      {
        label: 'Completed',
        orderById: 'NumberOfAssignmentsApolloCompleted',
        data: 'NumberOfAssignmentsApolloCompleted',
        block: 'assignments',
      },
      {
        label: 'Collaboration',
        orderById: 'NumberOfAssignmentsCollaboration',
        data: 'NumberOfAssignmentsCollaboration',
        block: 'assignments',
      },
      {
        label: 'Hold A',
        orderById: 'NumberOfAssignmentsHoldA',
        data: 'NumberOfAssignmentsHoldA',
        block: 'assignments',
      },
      {
        label: 'Hold B',
        orderById: 'NumberOfAssignmentsHoldB',
        data: 'NumberOfAssignmentsHoldB',
        block: 'assignments',
      },
      {
        label: 'Reviewed',
        orderById: 'NumberOfAssignmentsReviewed',
        data: 'NumberOfAssignmentsReviewed',
        block: 'assignments',
      },
      {
        label: 'Finalized',
        orderById: 'NumberOfAssignmentsApolloFinalized',
        data: 'NumberOfAssignmentsApolloFinalized',
        block: 'assignments',
      },
      {
        label: 'Emailed',
        orderById: 'NumberOfAssignmentsEmailed',
        data: 'NumberOfAssignmentsEmailed',
        block: 'assignments',
      },
      {
        label: 'Client Finalized',
        orderById: 'NumberOfAssignmentsClientFinalized',
        data: 'NumberOfAssignmentsClientFinalized',
        block: 'assignments',
      },
      {
        label: 'Locked',
        orderById: 'NumberOfAssignmentsLocked',
        data: 'NumberOfAssignmentsLocked',
        block: 'assignments',
      },
      {
        label: 'Excluded BC',
        orderById: 'NumberOfAssignmentsExcludedBC',
        data: 'NumberOfAssignmentsExcludedBC',
        block: 'assignments',
      },
      {
        label: 'Excluded PS',
        orderById: 'NumberOfAssignmentsExcludedPS',
        data: 'NumberOfAssignmentsExcludedPS',
        block: 'assignments',
      },
      {
        label: 'Excluded Excluded',
        orderById: 'NumberOfAssignmentsExcludedEx',
        data: 'NumberOfAssignmentsExcludedEx',
        block: 'assignments',
      },
      {
        label: 'Client Fee (Owning Office)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.ClientFeeOwningOffice, item.OwningOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Client Fee (FW Office)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.ClientFeeFieldworkOffice, item.FieldworkOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Client Fee (USD)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.ClientFeeUsd, 'USD'),
        block: 'multicurrencyfees',
      },
      {
        label: 'Fieldwork Fee (Owning Office)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.FieldworkFeeOwningOffice, item.OwningOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Fieldwork Fee (FW Office)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.FieldworkFeeFieldworkOffice, item.FieldworkOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Fieldwork Fee (USD)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.FieldworkFeeUsd, 'USD'),
        block: 'multicurrencyfees',
      },
      {
        label: 'Eval Fee Leftover (Owning Office)',
        orderById: '',
        data: (item) =>
          PlanningDetailsItem.FormatMoney(item.EvaluatorFeeLeftoverOwningOffice, item.OwningOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Eval Fee Leftover (FW Office)',
        orderById: '',
        data: (item) =>
          PlanningDetailsItem.FormatMoney(item.EvaluatorFeeLeftoverFieldworkOffice, item.FieldworkOfficeCurrency),
        block: 'multicurrencyfees',
      },
      {
        label: 'Eval Fee Leftover (USD)',
        orderById: '',
        data: (item) => PlanningDetailsItem.FormatMoney(item.EvaluatorFeeLeftoverUsd, 'USD'),
        block: 'multicurrencyfees',
      },
    ];
  }
}
